import React from 'react';
import PropTypes from 'prop-types';
import SvgElement from '../../uiElements/svgElement/SvgElement';

import '../../../styles/_grid.scss';
import './_contributorsBlock.scss';

const mstatusIconPlaceholder = '/assets/miljostatus/logo/Miljostatus_Logo_Hoved_Sort_RGB.svg';
const logoMiljodir = '/assets/logo/new/logo-secondary-black.svg';
const logoFisk = '/assets/miljostatus/icons/logo_bw_fiskeridirektoratet.svg';
const logoHav = '/assets/miljostatus/icons/logo_bw_havforskningsinstituttet.svg';
const logoKyst = '/assets/miljostatus/icons/logo_bw_kystverket.svg';
const logoMat = '/assets/miljostatus/icons/logo_bw_mattilsynet.svg';
const logoPolar = '/assets/miljostatus/icons/logo_bw_norsk_polarinstitutt.svg';
const logoRiksantik = '/assets/miljostatus/icons/logo_bw_riksantikvaren.svg';
const logoStraaling = '/assets/miljostatus/icons/logo_bw_dsa.svg';
const logoMet = '/assets/icons/logo_bw_met_grey.svg';
const logoArt = '/assets/icons/logo_bw_artsdatabanken.svg';
const logoEnova = '/assets/miljostatus/icons/logo_bw_enova.svg';
const logoKultur = '/assets/icons/logo_bw_kulturminnefondet.svg';
const logoMarfo = '/assets/icons/logo_bw_marfo.svg';

const getIcon = (iconName) => {
    switch (iconName) {
    case 'miljodirektoratet':
        return logoMiljodir;
    case 'fiskeridirektoratet':
        return logoFisk;
    case 'havforskningsinstituttet':
        return logoHav;
    case 'kystverket':
        return logoKyst;
    case 'mattilsynet':
        return logoMat;
    case 'norsk_polarinstitutt':
        return logoPolar;
    case 'riksantikvaren':
        return logoRiksantik;
    case 'dsa':
        return logoStraaling;
    case 'met_grey':
    case 'met':
        return logoMet;
    case 'artsdatabanken':
        return logoArt;
    case 'enova':
        return logoEnova;
    case 'kulturminnefondet':
        return logoKultur;
    case 'marfo':
        return logoMarfo;
    default:
        return mstatusIconPlaceholder;
    }
};

const ContributorsBlock = props => (
    <div className="c_mstatus-contributors g_container g_container--full">
        {props.heading && props.heading.length > 0 &&
        <h2 className="c_mstatus-contributors__heading u_hide-from-anchor-menu">
            {props.heading}
        </h2>
        }
        <div className="c_mstatus-contributors__inner-container">
            {props.contributors.map(item => (
                <a
                    className="c_mstatus-contributors__item"
                    key={`contrLogoKey__${item.heading}`}
                    href={item.url != null ? item.url.uri : '#'}
                >
                    <SvgElement
                        src={getIcon(item.icon)}
                        title={item.heading}
                        desc={`Logo for ${item.heading}`}
                    />
                    <span className="c_mstatus-contributors__item-text">{item.heading}</span>
                </a>
            ))}
        </div>
    </div>
);

ContributorsBlock.propTypes = {
    heading: PropTypes.string,
    contributors: PropTypes.arrayOf(PropTypes.shape({
        heading: PropTypes.string.isRequired,
        url: PropTypes.object.isRequired,
        icon: PropTypes.string.isRequired
    })).isRequired
};

export default ContributorsBlock;
